export const GET_SIZE_REQUESTED = "GET_SIZE_REQUESTED";
export const GET_SIZE_SUCCEEDED = "GET_SIZE_SUCCEEDED";
export const EDIT_SIZE_REQUESTED = "EDIT_SIZE_REQUESTED";
export const EDIT_SIZE_SUCCEEDED = "EDIT_SIZE_SUCCEEDED";
export const DELETE_SIZE_REQUESTED = "DELETE_SIZE_REQUESTED";
export const DELETE_SIZE_SUCCEEDED = "DELETE_SIZE_SUCCEEDED";
